import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            setVisible(window.scrollY > 600);
        };

        window.addEventListener("scroll", toggleVisibility, { passive: true });
        toggleVisibility();
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    if (!visible) return null;

    return (
        <button
            type="button"
            onClick={scrollToTop}
            aria-label="Scroll back to top"
            className="fixed bottom-5 left-5 z-40 p-3 rounded-full bg-ink-800/85 backdrop-blur-md border border-white/10 text-ink-200 hover:text-white hover:border-brand/50 hover:bg-ink-700 shadow-lg transition-all duration-300 hover:scale-105 group"
        >
            <ArrowUp size={16} className="group-hover:-translate-y-0.5 transition-transform" />
        </button>
    );
}
